// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"258":"Background","760":"Speaking","877":"Projects"}[chunkId] || chunkId) + "." + {"258":"195ae73e","275":"bcc00c8b","760":"dcd0be10","877":"598e7b3b"}[chunkId] + ".chunk.js";
};